import React from 'react';
import styled from '@emotion/styled/macro';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import EmptyState from 'components/EmptyState/EmptyState';
import Button from 'components/Button';
import { authActions } from 'redux/auth';

const NarrowEmptyState = styled(EmptyState)`
  padding-top: 0rem;
  padding-bottom: 0rem;
`;

const NoWorkspace = () => {
  const { t } = useTranslation(['component']);
  const dispatch = useDispatch();

  const logout = () => dispatch(authActions.logout());

  return <NarrowEmptyState title={t('postFeed.noWorkspace')} subtitle={<Button onClick={logout}>{t('userMenu.logout')}</Button>} />;
};

export default NoWorkspace;
